import React, { useEffect } from 'react';

import { AuthProvider } from './auth';
import { ToastProvider } from './toast';
import { OnlineStatusProvider } from './onlineStatus';
import { SyncProvider } from './sync';
import { AnimalFiltersProvider } from './animalFilters';
import { DarkModeProvider, useDarkMode } from './darkMode';

import { ThemeProvider } from 'styled-components';
import darkTheme from '../styles/themes/dark';
import lightTheme from '../styles/themes/light';

const AppProvider: React.FC = ({ children }) => {
  return (
    <AuthProvider>
      <ToastProvider>
        <OnlineStatusProvider>
          <SyncProvider>
            <DarkModeProvider>
              <AnimalFiltersProvider>
                <ThemeWrapper>{children}</ThemeWrapper>
              </AnimalFiltersProvider>
            </DarkModeProvider>
          </SyncProvider>
        </OnlineStatusProvider>
      </ToastProvider>
    </AuthProvider>
  );
};

const ThemeWrapper: React.FC = ({ children }) => {
  const { isDark } = useDarkMode();

  return (
    <ThemeProvider theme={isDark ? darkTheme : lightTheme}>
      {children}
    </ThemeProvider>
  );
};

export default AppProvider;
